import { React, PT, fetchApi } from '@gasbuddy/react';
import { Modal, Button, Dimmer, Loader, Form, Message, List } from 'semantic-ui-react';

export class BlockModal extends React.Component {
  state = {}

  saveAndClose = async () => {
    const { block, no_cc: noCc } = this.state;
    const { accountId, onUpdate } = this.props;

    const { body, status, error } = await fetchApi({
      url: `/identity/user/${accountId}/payment-blocks`,
      catchErrors: true,
      body: { block, no_cc: noCc },
    });
    if (error || status !== 200) {
      this.setState({ error: body || error, loading: false });
    } else {
      onUpdate();
      this.setState({ opened: false, error: null, loading: false });
    }
  }

  render() {
    const {
      block: propBlock, no_cc: propNoCc, property_frozen: propertyFrozen, block_reason: blockReason,
    } = this.props;
    const { opened, loading, error } = this.state;
    // An OFAC block is owned by payment-serv's compliance flow and is lifted only by the
    // unblock action in Retool. This route writes account_annotation directly, so clearing
    // the box here would lift a sanctions block with no compliance record of who did it.
    const ofacOwned = blockReason === 'ofac';
    return (
      <Modal
        open={opened}
        trigger={<Button floated="right" size="mini" onClick={() => this.setState({ opened: true })}>Blocks</Button>}
      >
        <Modal.Header>Account Level Payment Blocks</Modal.Header>
        <Modal.Content>
          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <div>
              {error
                && (
                <Message negative>
                  <Message.Content>
                    <List>
                      <List.Header>Cannot set account level blocks:</List.Header>
                      <List.Item>
                        {error.message}
                      </List.Item>
                    </List>
                  </Message.Content>
                </Message>
                )
              }
              {propertyFrozen && (
                <Message warning>
                  <Message.Content>
                    <strong>Account property is frozen by OFAC enforcement</strong>
                    <ul>
                      <li>Coupon expiry is paused and GasBack is held</li>
                      <li>Use the OFAC actions in Retool to reject or unblock</li>
                    </ul>
                  </Message.Content>
                </Message>
              )}
              <Form>
                <Form.Checkbox
                  label="Block from Payments Activity In General (but not earning GasBack)"
                  defaultChecked={propBlock}
                  disabled={ofacOwned}
                  onChange={(d, v) => this.setState({ block: v.checked })}
                />
                <Form.Checkbox
                  label="Block from using Credit Card to settle debt"
                  defaultChecked={propNoCc}
                  onChange={(d, v) => this.setState({ no_cc: v.checked })}
                />
              </Form>
            </div>
          </Dimmer.Dimmable>
        </Modal.Content>
        <Modal.Actions>
          <Button basic onClick={() => this.setState({ opened: false })}>
            Cancel
          </Button>
          <Button basic onClick={this.saveAndClose}>
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

BlockModal.propTypes = {
  accountId: PT.number,
  block: PT.bool,
  no_cc: PT.bool,
  property_frozen: PT.bool,
  block_reason: PT.string,
  onUpdate: PT.func.isRequired,
};

BlockModal.defaultProps = {
  accountId: 0,
  block: false,
  no_cc: false,
  property_frozen: false,
  block_reason: null,
};
